import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/* The FullscreenService service provides a way to toggle the visibility of a fullscreen mode using
BehaviorSubject. */
export class FullscreenService {

  private showFullscreen = new BehaviorSubject<boolean>(false);
  public showFullscreen$ = this.showFullscreen.asObservable();

  constructor() { }

  /**
   * The function toggles the fullscreen mode by emitting a boolean value through a subject.
   * @param {boolean} show - A boolean value indicating whether to show or hide the fullscreen mode.
   */
  toggleFullscreen(show: boolean) {
    this.showFullscreen.next(show);
  }
}